/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '~/pages/SignIn';
import Dashboard from '~/pages/Dashboard';
import GeneralIndicators from '~/pages/GeneralIndicators';
import Page404 from '~/pages/404';
import Forgot from '~/pages/Forgot';
import Recovery from '~/pages/RecoveryPassword';
import InstituicoesParticipantes from '~/pages/InstituicoesParticipantes';

import SelecaoDasLinhasDeCuidado from '~/pages/SelecaoDasLinhasDeCuidado';
import Indicadores from '~/pages/Indicadores';

import CadastroInstituicao from '~/pages/CadastroInstituicao';

import PerfilDoHospital from '~/pages/PerfilDoHospital';
import PerfilGeraisDosHospitais from '~/pages/PerfilGeraisDosHospitais';
import IndicadoresInstituicao from '~/pages/IndicadoresInstituicao';

import UsuariosDoSistema from '~/pages/UsuariosDoSistema';

import MinhaConta from '~/pages/MinhaConta';
import Usuario from '~/pages/Usuario';
import AreaDeSuporte from '~/pages/AreaDeSuporte';
import Ajuda from '~/pages/Ajuda';

import RegistroDeOperacoes from '~/pages/RegistroDeOperacoes';
import RegistroDeAcessos from '~/pages/RegistroDeAcessos';
import ResumoDeEventos from '~/pages/ResumoDeEventos';

import LinhasDeCuidadoFormulario from '~/pages/LinhasDeCuidadoFormulario';
import AdicionarLinhaDeCuidado from '~/pages/LinhasDeCuidado';
import LinhasDeCuidadoGrid from '~/pages/LinhasDeCuidadoGrid';
import LinhasDeCuidadoErros from '~/pages/LinhasDeCuidadoErros';
import LinhasDeCuidadoDadosFaltantes from '~/pages/LinhasDeCuidadoDadosFaltantes';

import FichadeColetaAVC from '~/pages/LinhasDeCuidado/Avc';
import FichadeColetaCancerDeMama from '~/pages/LinhasDeCuidado/CancerDeMama';
import FichadeColetaQuadril from '~/pages/LinhasDeCuidado/Quadril';
import FichadeColetaSepse from '~/pages/LinhasDeCuidado/Sepse';
import FichadeColetaSCA from '~/pages/LinhasDeCuidado/Sca';
import FichadeColetaCancerDeProstata from '~/pages/LinhasDeCuidado/CancerDeProstata';

import Download from '~/pages/Download';
import DashboardCompletude from '~/pages/DashboardCompletude';
import DashboardEstratificacao from '~/pages/DashboardEstratificacao';
import TermoDeAceite from '~/pages/TermoDeAceite';

import ResumoEvento from '~/pages/ResumoEvento';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/esqueceu-senha" exact component={Forgot} />
      <Route path="/recuperar-senha" exact component={Recovery} />
      <Route path="/indicadores-gerais" component={Dashboard} isPrivate codigoTela="MSG_INDICADORES_GERAIS" />

      <Route
        path="/enviar-indicadores-gerais"
        active="true"
        component={GeneralIndicators}
        isPrivate
        codigoTela="MSG_ENVIAR_INDICADORES_GERAIS"
      />
      <Route
        path="/administrador/instituicoes-participantes"
        component={InstituicoesParticipantes}
        isPrivate
      />

      {/*
       *
       * CADASTRO INSTITUICAO
       *
       */}

      <Route
        path="/administrador/adicionar-nova-instituicao"
        component={CadastroInstituicao}
        isPrivate
      />

      <Route
        path="/administrador/informacoes-institucionais"
        component={CadastroInstituicao}
        isPrivate
        codigoTela="MSG_INF_INSTITUCIONAIS"
      />

      <Route
        path="/administrador/instituicao/:id"
        component={CadastroInstituicao}
        isPrivate
      />

      {/*
       *
       * CADASTRO INSTITUICAO
       *
       */}

      <Route
        path="/administrador/selecao-das-linhas-de-cuidado"
        component={SelecaoDasLinhasDeCuidado}
        isPrivate
      />

      <Route
        path="/administrador/selecao-das-linhas-de-cuidado/:id"
        component={SelecaoDasLinhasDeCuidado}
        isPrivate
      />

      <Route
        path="/administrador/indicadores"
        component={Indicadores}
        isPrivate
      />
      <Route
        path="/administrador/indicadores/:id"
        component={Indicadores}
        isPrivate
      />

      <Route
        path="/administrador/perfil-do-hospital"
        component={PerfilDoHospital}
        isPrivate
        codigoTela="MSG_PERFIL_HOSPITAL"
      />
      <Route
        path="/administrador/perfil-do-hospital/:id"
        component={PerfilDoHospital}
        isPrivate
        codigoTela="MSG_PERFIL_HOSPITAL"
      />

      <Route
        path="/administrador/perfil-geral-dos-hospitais"
        component={PerfilGeraisDosHospitais}
        isPrivate
      />

      <Route
        path="/administrador/indicadores-competencias"
        component={IndicadoresInstituicao}
        isPrivate
        codigoTela="MSG_ADMIN_IND_COMP"
      />

      <Route
        path="/administrador/usuarios-do-sistema"
        component={UsuariosDoSistema}
        isPrivate
        codigoTela="MSG_ADMIN_USU_SISTEMA"
      />

      <Route path="/administrador/novo-usuario" component={Usuario} isPrivate />
      <Route
        path="/administrador/editar-usuario/:id"
        component={Usuario}
        isPrivate
      />

      <Route path="/minha-conta" component={MinhaConta} isPrivate />
      <Route
        path="/administrador/minha-conta"
        component={MinhaConta}
        isPrivate
      />

      <Route path="/area-de-suporte" component={AreaDeSuporte} isPrivate codigoTela="MSG_SUPORTE" />
      <Route path="/ajuda" component={Ajuda} isPrivate />

      <Route
        path="/registros-de-operacoes/registro-de-acessos"
        component={RegistroDeAcessos}
        isPrivate
        codigoTela="MSG_REG_OPERACOES_ACESSOS"
      />

      <Route
        path="/registros-de-operacoes/resumo-de-eventos"
        component={ResumoDeEventos}
        isPrivate
      />

      <Route
        path="/registros-de-operacoes/resumo-do-evento"
        component={ResumoEvento}
        isPrivate
      />

      <Route
        path="/registros-de-operacoes"
        component={RegistroDeOperacoes}
        isPrivate
        codigoTela="MSG_REG_OPERACOES"
      />

      <Route
        path="/linhas-de-cuidado/:indicador"
        component={AdicionarLinhaDeCuidado}
        isPrivate
        codigoTela="MSG_ADD_LINHAS_DE_CUIDADO"
      />

      <Route
        path="/linha-de-cuidado/:indicador"
        component={LinhasDeCuidadoGrid}
        isPrivate
        codigoTela="MSG_LINHAS_DE_CUIDADO"
      />
      <Route
        path="/relatorio-de-inconsistencias/:indicador"
        component={LinhasDeCuidadoErros}
        isPrivate
        codigoTela="MSG_REL_INCONSISTENCIA"
      />
      <Route
        path="/linhas-de-cuidado-dados-faltantes/:indicador"
        component={LinhasDeCuidadoDadosFaltantes}
        isPrivate
        codigoTela="MSG_LINHAS_CUIDADO_FALT"
      />
      <Route
        path="/formulario-linha-de-cuidado/:indicador"
        isPrivate
        component={LinhasDeCuidadoFormulario}
      />

      <Route
        path="/formulario-linhas-de-cuidado/acidente_vascular_cerebral"
        isPrivate
        component={FichadeColetaAVC}
      />

      <Route
        path="/formulario-linhas-de-cuidado/cancer_de_mama"
        isPrivate
        component={FichadeColetaCancerDeMama}
      />

      <Route
        path="/formulario-linhas-de-cuidado/artropatia_de_quadril"
        isPrivate
        component={FichadeColetaQuadril}
      />

      <Route
        path="/formulario-linhas-de-cuidado/cancer_de_prostata"
        isPrivate
        component={FichadeColetaCancerDeProstata}
      />

      <Route
        path="/formulario-linhas-de-cuidado/sepse_e_choque_septico"
        isPrivate
        component={FichadeColetaSepse}
      />

      <Route
        path="/formulario-linhas-de-cuidado/sindrome_coronariana_aguda"
        isPrivate
        component={FichadeColetaSCA}
      />

      <Route path="/dados/download-de-dados" isPrivate component={Download} codigoTela="MSG_DOWNLOAD_DADOS" />
      <Route
        path="/dados/completude"
        isPrivate
        component={DashboardCompletude}
        codigoTela="MSG_COMPLETUDE"
      />
      <Route path="/aceitar-termo" isPrivate component={TermoDeAceite} />

      <Route
        path="/estratificacao/clinicas_geral"
        isPrivate
        component={DashboardEstratificacao}
        codigoTela="MSG_EST_CLINICA_GERAL"
      />
      <Route
        path="/estratificacao/clinicas_avc"
        isPrivate
        component={DashboardEstratificacao}
        codigoTela="MSG_EST_CLINICA_AVC"
      />
      <Route
        path="/estratificacao/clinicas_sca"
        isPrivate
        component={DashboardEstratificacao}
        codigoTela="MSG_EST_CLINICA_SCA"
      />
      <Route
        path="/estratificacao/clinicas_sepse"
        isPrivate
        component={DashboardEstratificacao}
        codigoTela="MSG_EST_CLINICA_SEPSE"
      />
      <Route
        path="/estratificacao/clinicas_quadril"
        isPrivate
        component={DashboardEstratificacao}
        codigoTela="MSG_EST_CLINICA_QUADRIL"
      />
      <Route
        path="/estratificacao/clinicas_prostata"
        isPrivate
        component={DashboardEstratificacao}
        codigoTela="MSG_EST_CLINICA_PROSTATA"
      />
      <Route
        path="/estratificacao/clinicas_mama"
        isPrivate
        component={DashboardEstratificacao}
        codigoTela="MSG_EST_CLINICA_MAMA"
      />

      <Route component={Page404} />
    </Switch>
  );
}
